import InputBlocked from "./blocked";

export default InputBlocked;
